export default __webpack_public_path__ + "static/media/manage-icon-gray.b99394f4.svg";